import { render } from "./Footer.vue?vue&type=template&id=2781641c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2781641c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2781641c"

export default script